import { PrismicRichText } from "@prismicio/react";
import React from 'react';
import { useEffect } from "react";

export const Timeline = (props) => {

    const sc = props.slice.primary;

    const items = props.slice.items;

    let bg = sc.background === "gradient" ? "gradient-to-t from-grey-light to-white" : sc.background;

    const components = {
        label: ({ children }) => (
          <sup>{children}</sup>
        ),
    }
    let space = sc.spacing;

  if (space === "Both large") {
    space = "gutter";
  } else if (space === "Both small") {
    space = "gutter sm";
  } else if (space === "Top large") {
    space = "gutter bot";
  } else if (space === "Top small") {
    space = "gutter bot sm";
  } else if (space === "Bottom large") {
    space = "gutter top";
  } else {
    space = "gutter top sm";
  }

  
    useEffect(() => {
        const section = document.querySelectorAll('.box')
        const options = {
            threshold: 1
        }
        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(entry => {
                if(!entry.isIntersecting){
                    return;
                }
                entry.target.classList.add('go')
            })
        }, options)
        section.forEach(sec => {
            observer.observe(sec)
        })
    }, [])

    return (
        <section className={"relative gutter top bg-" + bg + " " + space}>
            <div className="wrapper">
            <div className="timeline">
                {items.map((item, index) => {
                    return (
                        <div key={index} className={"box" + (item.featured ? ' fea' : ' nor')}>
                            <div className="textbox">
                            <PrismicRichText field={item.timeline_content.richText} components={components} />
                            </div>
                        </div>
                    )
                })}
            </div>
            </div>
        </section>
            
    );
}

